import { storage } from "../../utils/localStorage";

export const fetchBlob = (uri, payload) => {
  return new Promise((resolve, reject) => {
    const { token } = storage.getCredsFromLocalStorage();
    var xhr = new XMLHttpRequest();

    // Use POST if payload is provided, otherwise GET
    const method = payload ? "POST" : "GET";
    xhr.open(method, uri, true);
    xhr.setRequestHeader("Authorization", `Bearer ${token}`);

    // Set content type for POST requests
    if (payload) {
      xhr.setRequestHeader("Content-Type", "application/json");
    }

    xhr.responseType = "arraybuffer";

    xhr.onload = function (e) {
      if (this.status === 200) {
        var blob = this.response;
        resolve(blob);
      } else {
        reject(new Error(`Failed to fetch blob: ${this.statusText}`));
      }
    };

    xhr.onerror = function () {
      reject(new Error("Network error"));
    };

    // Send payload as JSON string if provided
    xhr.send(payload ? JSON.stringify(payload) : null);
  });
};

export const blobToBase64Url = (blob, type = "image/png") => {
  const base64String = btoa(
    String.fromCharCode.apply(null, new Uint8Array(blob))
  );
  return `data:${type};base64,${base64String}`;
};
